var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModule4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 1C20 2.65685 18.6569 4 17 4H3C1.34315 4 0 2.65685 0 1C0 0.44772 0.44772 0 1 0H19C19.5523 0 20 0.44772 20 1Z",
    fill: "#474C5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H3C1.34315 6 0 7.34315 0 9C0 10.6569 1.34315 12 3 12H6C7.65685 12 9 10.6569 9 9C9 7.34315 7.65685 6 6 6Z",
    fill: "#A2AACA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 18C0 15.7909 1.79086 14 4 14H6C7.65685 14 9 15.3431 9 17C9 18.6569 7.65685 20 6 20H1C0.44772 20 0 19.5523 0 19V18Z",
    fill: "#A2AACA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 6H14C12.3431 6 11 7.34315 11 9C11 10.6569 12.3431 12 14 12H17C18.6569 12 20 10.6569 20 9C20 7.34315 18.6569 6 17 6Z",
    fill: "#A2AACA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 20H14C12.3431 20 11 18.6569 11 17C11 15.3431 12.3431 14 14 14H16C18.2091 14 20 15.7909 20 18V19C20 19.5523 19.5523 20 19 20Z",
    fill: "#A2AACA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19 6C19.5523 6 20 5.55228 20 5C20 4.44772 19.5523 4 19 4H1C0.447715 4 0 4.44772 0 5C0 5.55228 0.447715 6 1 6H6C7.65685 6 9 7.34315 9 9C9 10.6569 7.65685 12 6 12H1C0.447715 12 0 12.4477 0 13C0 13.5523 0.447715 14 1 14H6C7.65685 14 9 15.3431 9 17V19C9 19.5523 9.44771 20 10 20C10.5523 20 11 19.5523 11 19V17C11 15.3431 12.3431 14 14 14H19C19.5523 14 20 13.5523 20 13C20 12.4477 19.5523 12 19 12H14C12.3431 12 11 10.6569 11 9C11 7.34315 12.3431 6 14 6H19Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModule4);
export default __webpack_public_path__ + "static/media/module_4.c5e6b7b935d30c77298f5650dfbf3637.svg";
export { ForwardRef as ReactComponent };